import { BookOpenCheckIcon, ClipboardCheckIcon, LayersIcon, MessagesSquareIcon, RouteIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Career Transition Roadmap: From Electrician or HVAC Technician to Data Center Professional',
    description: 'Map your current skills to data center roles and follow a structured path.',
    icon: RouteIcon,
  },
  {
    number: '2',
    title: 'Data Center Technical Glossary',
    description: 'An A–Z reference of the terms and acronyms used in power, cooling, operations and safety.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '3',
    title: 'Quick Reference Cards: Critical Systems at a Glance',
    description: 'One-page cards that summarize each critical system for fast review.',
    icon: LayersIcon,
  },
  {
    number: '4',
    title: 'Technical Interview Preparation Guide',
    description: 'Questions by topic, what each one tests and how to structure strong, honest answers.',
    icon: MessagesSquareIcon,
  },
  {
    number: '5',
    title: 'Preventive Maintenance Checklists for Critical Systems',
    description: 'Inspection and maintenance checklists organized by system and frequency.',
    icon: ClipboardCheckIcon,
  },
];
